import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"20px 0 40px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","color":"black","border":"0"} }, "1. Choose an Image")
], -1)
const _hoisted_2 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_3 = { style: {"margin":"30px 0","width":"80%"} }
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = { class: "holly-data" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"40px 0 40px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    style: {"font-size":"35px","color":"black","border":"0"},
    id: "title-2"
  }, "2. Choose Concepts to Explore")
], -1)
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "holly-data" }
const _hoisted_9 = { class: "holly-detect" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"20px 0 20px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","color":"black","border":"0"} }, "3. The Input Image")
], -1)
const _hoisted_11 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"20px 0 20px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","color":"black","border":"0"} }, "4. Chosen Concepts")
], -1)
const _hoisted_13 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"20px 0 20px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","color":"black","border":"0"} }, "5. TCVA scores")
], -1)
const _hoisted_15 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_16 = { class: "demo-image__error" }
const _hoisted_17 = { class: "block" }
const _hoisted_18 = { class: "image-slot" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {router} from "@/router";
import {ElMessage} from "element-plus";
import request from "@/api";
import {reactive, ref} from "vue";
import {useStore} from "vuex";
import axios from "axios";
import DataUpload from "./DataUpload.vue";

const ConceptPool_page_size = 3;

export default /*#__PURE__*/_defineComponent({
  __name: 'tcav',
  setup(__props) {

const componentKey = ref(0);
const last_id = ref(666)
const chosenModel = ref('')
const chosenImg = ref('')
const istrue = ref(false)
const chosenAlgorithm = ref('')
const activate = ref(-1)
const gpu = ref('')
const memory = ref('')
const error_img = ref([false, false])
const chosen = ref([])
let resultLoading = ref(false)
let resultShow = ref(false)

const GroundTruth = ref('')
const Predicted = ref('')
const Probability = ref('')

const chosenEnhanceAlgorithm = ref('')
const chosenStitchingAlgorithm = ref('')
const store = useStore();
const listPage = ref(1), imageNumber = ref(8);
const fileList = ref([]), datasetInformation = ref({}), fileList2 = ref([]);
let selectList = Array(imageNumber.value).fill(0);
let deleteShow = ref(false);
const showList = ref([]), showList2 = ref([]), showList3 = ref([]), listPreview = ref([]), showListPool = ref([]), listPreview2 = ref([]);
const ConceptPool = ref([]), conceptFileList = ref([]), conceptPreview = ref([]);
let ConceptPool_current_page = ref(5);
const radio = ref(['none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none',
  'none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none','none']);
const concept_re = ref('')
// 47

async function refreshImages(option) { //推理之后才提交的, 刷新右边的结果
  // console.log(option);
  await getDatasetInfos(option);
  updateShowList();
}

async function getDatasetInfos(option) {
  let requestUrl = "/dataset/" + option, requestData = {};
  requestData["datasetId"] = 666; //其实用不上
  await request.post(requestUrl, requestData)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          fileList.value = (res.data.data);
        } else {
          console.log("err request");
        }
      })
      .catch((err) => {
        console.log(err);
      });
}

const updateShowList = () => {
  showList.value = fileList.value
  console.log("showList.value", showList.value);
  listPreview.value = (showList.value.map((e) => {
    return "http://" + e;
  }));
  console.log("listPreview.value", listPreview.value)
};


async function realRefreshImages(option){  //图像池的刷新
  await getImgPoolInfos(option);
  updatePoolList();
}

async function RefreshConcepts(){  //图像池的刷新
  await getConcepts();
  updateConceptList();
}

async function getImgPoolInfos(option){
  let requestUrl = "/dataset/" + option, requestData = {};
  requestData["datasetId"] = 10002;
  await request.post(requestUrl, requestData)
      .then((res) => {
        console.log(res.data);

        if (res.status === 200) {
          chosen.value[0] = res.data.data[0]
          fileList2.value = (res.data.data);
        } else {
          console.log("err request");
        }
      })
      .catch((err) => {
        console.log(err);
      });
}

async function getConcepts(){
  let requestUrl = "/dataset/getConcepts", requestData = {};
  requestData["datasetId"] = 20001;
  await request.post(requestUrl, requestData)
      .then((res) => {
        // console.log("res.data: ", res.data);
        if (res.status === 200) {
          conceptFileList.value = res.data.data;
          // console.log("request success!");
          // fileList2.value = (res.data.data);
        } else {
          console.log("err request");
        }
      })
      .catch((err) => {
        console.log(err);
      });
}

const updatePoolList = () => {
  showListPool.value = fileList2.value
  console.log("showListPool.value", showListPool.value);
  listPreview2.value = (showListPool.value.map((e) => {
    return "http://" + e;
  }));
  console.log("listPreview2.value", listPreview2.value)
};

const updateConceptList = () => {
  ConceptPool.value = conceptFileList.value
  console.log("ConceptPool.value", ConceptPool.value);
  // listPreview2.value = (showListPool.value.map((e) => {
  //   return "http://" + e;
  // }));
  // console.log("listPreview2.value", listPreview2.value)
};

function refreshCifar(){  //懒得改名字了~
  realRefreshImages("getPool");
  activate.value = -1;
  // let last_d = document.getElementById(last_id.value.toString()) //对应被注释掉的那种写法
  // last_d.style.border = "2px solid white";
  // last_id.value == 666
}

function refreshConcept(){
  RefreshConcepts();
}

realRefreshImages("getPool");
RefreshConcepts();

const selectChange = (index) => {
  selectList[index] ^= 1;
  console.log(selectList);
};

function uploadDataset() {
  router.push('datasetPreview')
}

// changeColor(()=>{
//   this.$refs.abc.style.border = '2px solid red';
// })
function changeColor(event){  // vue正常思路：用组件的active，但是好像要用data()，以后学了再改吧
  console.log("event", event)
  console.log("event.currentTarget.id", event.currentTarget.id)
  // console.log("document.getElementById(event.currentTarget.id).style.border", document.getElementById(event.currentTarget.id).style.border)
  let d = document.getElementById(event.currentTarget.id)
  d.style.border = "4px solid red";
  if(last_id.value == 666){
    last_id.value = event.currentTarget.id
  }else{
    let last_d = document.getElementById(last_id.value.toString())
    last_d.style.border = "2px solid white";
    last_id.value = event.currentTarget.id
  }
}
// const changeColor = () =>
// {
//     console.log(this.refs)
//     // this.refs.abc.style.border = '2px solid red';
//   // obj.style.border = '2px solid red';
// }

function chooseImg($event) {
  console.log("$event", $event)
  console.log("$event.srcElement.currentSrc", $event.srcElement.currentSrc)
  let arr = $event.srcElement.currentSrc.split("/")
  chosenImg.value = arr[arr.length - 1]
  chosen.value[0] = $event.srcElement.currentSrc.substring(7);
  console.log("图片名称", chosenImg.value)
  const title_2 = document.getElementById("title-2");
  if(title_2!==null)
    title_2.scrollIntoView()
}

const forceRerender = () => {
  console.log(componentKey.value)
  componentKey.value += 1;

};

async function startRecognize() {
  console.log("start Recognize")
  concept_re.value = ''
  for(let i=0; i<47; i++){
    if(radio.value[i]!="none"){
      concept_re.value += (radio.value[i]+"_");
    }
  }
  console.log("concept_re.value: ", concept_re.value)
  if(!concept_re.value){
    ElMessage.error('请至少选择一个概念');
    return
  }
  if(!chosenModel.value){
    ElMessage.error('请选择要使用的模型')
    return
  }
  if(!chosenAlgorithm.value){
    ElMessage.error('请选择要使用的算法')
    return
  }
  if(!chosenImg.value){
    ElMessage.error('请选择要解释的图像')
    return
  }
  resultLoading.value = true
  await request.post('/algorithm/callAlgorithm',{
    algorithmName:chosenAlgorithm.value,
    datasetId: 666,
    datasetName: "TCAV",
    modelName: concept_re.value,
    userName: chosenImg.value,
    // userName: store.state.username,
  })
      .then((response)=>{
        console.log("response", response)
        showList.value[0] = (response.data.data.result[0]);
        showList2.value[0] = (response.data.data.result[1]);
        showList3.value[0] = (response.data.data.result[2]);
        console.log("showList.value:", showList.value)
        console.log("showList2.value:", showList2.value)
        console.log("showList3.value:", showList3.value)
      })
      .catch((error)=>{
        console.error(error)
      })
  for(let i=0; i<47; i++){
    if(radio.value[i]!="none"){
      radio.value[i] = "none";
    }
  }

  await request.post('/algorithm/reportGpu',{
    algorithmName:chosenAlgorithm.value,
    datasetId: 666,
    datasetName: "ImageNet",
    modelName: chosenModel.value,
    userName: chosenImg.value,
    // userName: store.state.username,
  })
      .then((response)=>{
        gpu.value = response.data.data.result[0];
        memory.value = response.data.data.result[1];
      })
      .catch((error)=>{
        console.error(error)
      })
  resultShow.value = true
  resultLoading.value = false

  // showList.value = fileList.value
  //
  // console.log("showList.value", showList.value);
  // listPreview.value = (showList.value.map((e) => {
  //   return "http://" + e;
  // }));
  // console.log("listPreview.value", listPreview.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_aside, { style: {"background-color":"white","width":"50%","padding":"20px"} }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createBlock(_component_el_image, {
                src: `http://${chosen.value}`,
                fit: 'fill',
                style: 'width: 100%;',
                key: componentKey.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (chooseImg($event)))
              }, null, 8, ["src"]))
            ])
          ]),
          _createVNode(_component_el_row, { style: {"margin":"0 0 40px 0"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showListPool.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: 4,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      id: index,
                      class: "block2",
                      onClick: ($event: any) => (activate.value = index),
                      style: _normalizeStyle({border: activate.value === index ? '2px solid red' : '2px solid white'})
                    }, [
                      (_openBlock(), _createBlock(_component_el_image, {
                        src: `http://${item}`,
                        "initial-index": index,
                        style: {"width":"100%","height":"100%"},
                        fit: 'fill',
                        key: componentKey.value,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (chooseImg($event)))
                      }, null, 8, ["src", "initial-index"]))
                    ], 12, _hoisted_4)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              size: "large",
              type: "primary",
              onClick: refreshCifar,
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("刷新图像池")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "large",
              type: "warning",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("数据集介绍")
              ]),
              _: 1
            })
          ]),
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ConceptPool.value.slice((_unref(ConceptPool_current_page)-1)*ConceptPool_page_size, Math.min(ConceptPool.value.length, _unref(ConceptPool_current_page)*ConceptPool_page_size)), (item, index) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createVNode(_component_el_radio_group, {
                modelValue: radio.value[index],
                "onUpdate:modelValue": ($event: any) => ((radio.value[index]) = $event),
                style: {"margin":"10px 0 10px 0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: item['conceptName'],
                    size: "large",
                    border: "",
                    style: {"background":"white"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("with " + _toDisplayString(item['conceptName']), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]),
                  _createVNode(_component_el_radio, {
                    label: "none",
                    size: "large",
                    border: "",
                    style: {"background":"white"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("without " + _toDisplayString(item['conceptName']), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item['conceptAddress'], (item2, index2) => {
                    return (_openBlock(), _createBlock(_component_el_col, {
                      span: 4,
                      key: index2
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          id: index2,
                          class: "block2"
                        }, [
                          (_openBlock(), _createBlock(_component_el_image, {
                            src: `http://${item2}`,
                            "initial-index": index,
                            "preview-src-list": item['conceptAddress'].map(x=>'http://'+x),
                            style: {"width":"100%","height":"100%"},
                            fit: 'fill',
                            key: componentKey.value
                          }, null, 8, ["src", "initial-index", "preview-src-list"]))
                        ], 8, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]))
          }), 256)),
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next",
            "current-page": _unref(ConceptPool_current_page),
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(ConceptPool_current_page) ? (ConceptPool_current_page).value = $event : ConceptPool_current_page = $event)),
            "page-size": ConceptPool_page_size,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((ConceptPool_page_size) = $event)),
            total: ConceptPool.value.length,
            "onUpdate:total": _cache[4] || (_cache[4] = ($event: any) => ((ConceptPool.value.length) = $event)),
            style: {"justify-content":"center","margin":"25px"}
          }, null, 8, ["current-page", "total"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              size: "large",
              type: "primary",
              onClick: refreshConcept,
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("刷新概念池")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "large",
              type: "warning",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("概念数据集介绍")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_main, { style: {"background-color":"white"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_select, {
              modelValue: chosenModel.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((chosenModel).value = $event)),
              placeholder: "请选择神经网络模型",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  key: "6",
                  label: "GoogleNet",
                  value: "GoogleNet"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_select, {
              modelValue: chosenAlgorithm.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((chosenAlgorithm).value = $event)),
              placeholder: "请选择推理算法",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  key: "6",
                  label: "TCAV",
                  value: "TCAV"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              size: "large",
              type: "success",
              onClick: startRecognize,
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("开始推理")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            style: _normalizeStyle({visibility:_unref(resultShow)?'visible':'hidden'})
          }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList2.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createVNode(_component_el_image, {
                    src: `http://${item}`,
                    fit: 'fill',
                    "preview-src-list": showList2.value.map(x=>'http://'+x),
                    "initial-index": index
                  }, null, 8, ["src", "preview-src-list", "initial-index"])
                ]))
              }), 256))
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createVNode(_component_el_image, {
                    src: `http://${item}`,
                    fit: 'fill',
                    "preview-src-list": showList.value.map(x=>'http://'+x),
                    "initial-index": index
                  }, null, 8, ["src", "preview-src-list", "initial-index"])
                ]))
              }), 256))
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList3.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createVNode(_component_el_image, {
                    src: `http://${item}`,
                    fit: 'fill',
                    "preview-src-list": showList3.value.map(x=>'http://'+x),
                    "initial-index": index,
                    onError: ($event: any) => (error_img.value[index] = true),
                    onLoad: ($event: any) => (error_img.value[index] = false)
                  }, null, 8, ["src", "preview-src-list", "initial-index", "onError", "onLoad"]),
                  _withDirectives(_createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_image, null, {
                        error: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            _createTextVNode(" 遗憾！算法未能成功执行 "),
                            _hoisted_19,
                            _createTextVNode(" 可能是由于服务器算力不足、程序出错或其他原因 "),
                            _hoisted_20,
                            _createTextVNode(" 服务器当前可用最大算力：" + _toDisplayString(memory.value) + "，位于GPU " + _toDisplayString(gpu.value) + "上 ", 1),
                            _hoisted_21,
                            _createTextVNode("请稍后再试 ")
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ], 512), [
                    [_vShow, error_img.value[index]]
                  ])
                ]))
              }), 256))
            ])
          ], 4)
        ]),
        _: 1
      })), [
        [_directive_loading, _unref(resultLoading)]
      ])
    ]),
    _: 1
  }))
}
}

})